import React from "react";
import { withRouter } from "react-router-dom";
import { apiCallPost, niceDate, niceDateTime } from "./fns/util";
import _ from "lodash";
import { Button, Input, Space, Table, Tag, Spin, Alert } from "antd";
import SchedulerLayout from "./scheduler/SchedulerLayout";

// class PublicCommitmentList extends React.Component {
//   constructor(props) {
//     super(props);
//   }
//   state = {};

//   async componentDidMount() {
//     const delegateId = this.props.match.params.delegateId;
//     let res = await apiCallPost(
//       "NOT_AUTHED",
//       "/conference2023/getMyCommitments",
//       {
//         delegateId: delegateId,
//       }
//     );
//   }

//   render() {
//     return <div>Public Commitment List</div>;
//   }
// }

class PublicSchedule extends React.Component {
  state = {
    dataSource: [],
    isLoading: true,
  };

  async componentDidMount() {
    this.setState({
      isLoading: false,
      dataSource: [],
    });
  }

  render() {
    // Check if data is still loading
    if (this.state.isLoading) {
      return (
        <div>
          <Spin />
        </div>
      );
    }
    // Check if there was an error loading the data
    if (this.state.isError) {
      return (
        <Alert
          message="Error"
          description="An error occurred while loading the data."
          type="error"
          showIcon
        />
      );
    }

    return (
      <div
        style={{
          marginTop: "20px",
          marginLeft: "20px",
          marginRight: "20px",
        }}
      >
        <h3>Conference 2023 Schedule</h3>
        <SchedulerLayout
          isAdmin={false}
          context={{}}
          calendarResolution="00:15:00"
          setDay="1"
        />
      </div>
    );
  }
}

export default withRouter(PublicSchedule);
